module.exports = __webpack_public_path__ + "img/connector-types-desktop@2x.2fc36101.webp";